import { render, staticRenderFns } from "./Lang4Age1.vue?vue&type=template&id=283f241e&scoped=true&"
import script from "./Lang4Age1.vue?vue&type=script&lang=js&"
export * from "./Lang4Age1.vue?vue&type=script&lang=js&"
import style0 from "./Lang4Age1.vue?vue&type=style&index=0&id=283f241e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283f241e",
  null
  
)

export default component.exports